/* eslint-disable */
// WARNING: this file is generated by a script, don't change it manually!
export const ElevationBelowXs = {'boxShadow': '0px 2px 4px rgba(52, 53, 61, 0.12)'};
export const ElevationBelowS = {'boxShadow': '0px 4px 8px rgba(52, 53, 61, 0.12)'};
export const ElevationBelowM = {'boxShadow': '0px 8px 16px rgba(52, 53, 61, 0.12)'};
export const ElevationBelowL = {'boxShadow': '0px 16px 32px rgba(52, 53, 61, 0.12)'};
export const ElevationAboveXs = {'boxShadow': '0px -2px -4px rgba(52, 53, 61, 0.12)'};
export const ElevationAboveS = {'boxShadow': '0px -4px -8px rgba(52, 53, 61, 0.12)'};
export const ElevationAboveM = {'boxShadow': '0px -8px -16px rgba(52, 53, 61, 0.12)'};
export const ElevationAboveL = {'boxShadow': '0px -16px -32px rgba(52, 53, 61, 0.12)'};